import script from "./AvatarStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarStack.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarStack.vue?vue&type=style&index=0&id=4fa2c101&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa2c101"]])

export default __exports__